import { CSSProperties } from "react";
import styled from "styled-components";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      padding: spacing.m,
    },
    description: {
      textAlign: "center",
    },
    input: {
      backgroundColor: theme.input.background,
      width: "100%",
      padding: spacing.m,
      borderRadius: constants.radius.view,
      border: "none",
      textAlign: "center",
      outline: "none",
      height: 36,
      fontSize: 24,
      textTransform: "uppercase",
      fontFamily: '"Inter", sans-serif',
      fontWeight: 700,
      color: theme.input.text,
    },
    button: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    inputContainer: {
      position: "relative",
      width: "100%",
    },
    icon: {
      position: "absolute",
      right: 8,
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      color: "#b0b0b0",
    },
    statusText: {
      textAlign: "center",
      fontWeight: 600,
    },
  };

  return styles;
};

export const StyledInput = styled.input`
  &::placeholder {
    color: ${({ theme }) => theme.input.placeholder};
  }
`;
